//TODO: waiting for the backend and finish the integration
// eslint-disable-next-line no-unused-vars
const getReservationsContent = ({ userEmail, status }) => {
    // const sdnDomain = Sephora.configurationSettings.sdnApiHost;
    // const sdnDomain = 'https://store-experience-service-qa1.lower.internal.sephora.com'
    // const url = `${sdnDomain}/store-experience-service/v1/client/experience/reservations/user/${userEmail}?locale=en-US&status=${status}`

    // const data = ufeApi.makeRequest(url, {
    //     method: 'GET',
    //     headers: { 'x-requested-source': 'rwd', authorization: `Bearer ${token}` }
    // });

    //TODO: This is mock data, waiting for the BE Side to try to finish this.
    return Promise.resolve({
        data: [
            {
                status: 'UPCOMING',
                type: 'service',
                statusDisplayName: 'Upcoming',
                activityId: '11500002',
                bookingId: '552676',
                confirmationNumber: '6E71LDVO7O',
                startDateTime: '2024-05-19T20:30:00Z',
                duration: 30,
                activityDisplayName: 'Feature Focus',
                price: 100,
                artistName: 'Amy A',
                storeName: 'Sephora Powell Street',
                storeTimeZone: 'America/Los_Angeles',
                imageUrl: 'https://qa3.sephora.com/contentimages/happening/OLR-CD__perkface_30min.jpg'
            },
            {
                status: 'UPCOMING',
                type: 'service',
                statusDisplayName: 'Upcoming',
                activityId: '11500002',
                bookingId: '552676',
                confirmationNumber: '6E71LDVO7O',
                startDateTime: '2024-05-27T10:30:00Z',
                duration: 40,
                activityDisplayName: 'Feature Focus',
                price: 90,
                artistName: 'Amy A',
                storeName: 'Sephora Powell Street',
                storeTimeZone: 'America/Los_Angeles',
                imageUrl: 'https://qa3.sephora.com/contentimages/happening/OLR-CD__perkface_30min.jpg'
            },
            {
                status: 'UPCOMING',
                type: 'event',
                statusDisplayName: 'Upcoming',
                activityId: '11500002',
                bookingId: '552676',
                confirmationNumber: '6E71LDVO7O',
                startDateTime: '2024-05-27T10:30:00Z',
                duration: 40,
                activityDisplayName: 'Korea’s Best Kept Secret',
                price: null,
                artistName: null,
                storeName: 'Sephora Powell Street',
                storeTimeZone: 'America/Los_Angeles',
                imageUrl: 'https://qa3.sephora.com/contentimages/happening/OLR-CD__perkface_30min.jpg'
            }
        ]
    });
};

export default getReservationsContent;
